import { apiDelete } from 'api';
import { EmptyObject } from 'types';

export const deleteConsultee = (consulteeId: number): Promise<EmptyObject> =>
  apiDelete<EmptyObject>(`user/${consulteeId}/delete`);
